var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCup100(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 103,
    viewBox: "0 0 103 103",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1375_385)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1,
    width: 99,
    height: 99,
    rx: 15,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.625 69.25V60C47.375 59.5417 45.375 58.5729 43.625 57.0938C41.875 55.6146 40.6667 53.7708 40 51.5625C36.9167 51.2292 34.3125 49.9792 32.1875 47.8125C30.0625 45.6458 29 43.0417 29 40V37.25C29 36.2188 29.3672 35.3359 30.1016 34.6016C30.8359 33.8672 31.7188 33.5 32.75 33.5H39.25V31.75C39.25 30.7188 39.6172 29.8359 40.3516 29.1016C41.0859 28.3672 41.9688 28 43 28H60C61.0313 28 61.9141 28.3672 62.6484 29.1016C63.3828 29.8359 63.75 30.7188 63.75 31.75V33.5H70.25C71.2812 33.5 72.1641 33.8672 72.8984 34.6016C73.6328 35.3359 74 36.2188 74 37.25V40C74 43.0417 72.9375 45.6458 70.8125 47.8125C68.6875 49.9792 66.0833 51.2292 63 51.5625C62.3333 53.7708 61.125 55.6146 59.375 57.0938C57.625 58.5729 55.625 59.5417 53.375 60V69.25H61C61.5312 69.25 61.9766 69.4307 62.3359 69.7922C62.6953 70.1537 62.875 70.6016 62.875 71.1359C62.875 71.6703 62.6953 72.1146 62.3359 72.4688C61.9766 72.8229 61.5312 73 61 73H42C41.4688 73 41.0234 72.8193 40.6641 72.4578C40.3047 72.0963 40.125 71.6484 40.125 71.1141C40.125 70.5797 40.3047 70.1354 40.6641 69.7812C41.0234 69.4271 41.4688 69.25 42 69.25H49.625ZM39.25 47.625V37.25H32.75V40C32.75 41.875 33.3646 43.5104 34.5938 44.9062C35.8229 46.3021 37.375 47.2083 39.25 47.625ZM51.5147 56.4375C53.8799 56.4375 55.8854 55.605 57.5312 53.9401C59.1771 52.2752 60 50.2535 60 47.875V31.75H43V47.875C43 50.2535 43.8278 52.2752 45.4834 53.9401C47.1391 55.605 49.1495 56.4375 51.5147 56.4375ZM63.75 47.625C65.625 47.2083 67.1771 46.3021 68.4062 44.9062C69.6354 43.5104 70.25 41.875 70.25 40V37.25H63.75V47.625Z",
    fill: "#044535"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1375_385",
    x: 0,
    y: 0,
    width: 103,
    height: 103,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.117647 0 0 0 0 0.117647 0 0 0 0 0.117647 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1375_385"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1375_385",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCup100);
export default __webpack_public_path__ + "static/media/cup100.5e5a4700f82dc36d03913f7353b2f8cc.svg";
export { ForwardRef as ReactComponent };